import React from 'react';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-mobile-alt',
      title: 'Software Application Development',
      description: 'We develop software solutions adapted and suitable to our clients needs in whatever field of endeavor. We develop applications that run on mobile devices (Android and iOS) and Desktop (Windows, Linux and MacOS).',
      link: 'https://metroblue.com.ng/software'
    },
    {
      icon: 'fab fa-chrome',
      title: 'Web Design and Development',
      description: 'Our team of professional designers and developers make things happen. We build world class web applications that brings your ideas into reality and help you achieve your desired goals.',
      link: 'https://metroblue.com.ng/website'
    },
    {
      icon: 'fas fa-shopping-cart',
      title: 'Digital Marketing',
      description: 'We don\'t just create software applications and leave you in the dark. Our professional digital marketers could follow you through your digital journey to ensure you successfully reach more audience online.',
      link: 'https://metroblue.com.ng/digitalmarketing'
    },
    {
      icon: 'fab fa-apple',
      title: 'Corporate Branding and Graphics',
      description: 'Have a business idea? looking for a brand that will set your business apart. We give your business brand an appealing attraction clients can\'t resist. We also create cutting edge designs for your organisation.',
      link: 'https://metroblue.com.ng/graphics'
    }
  ];

  return (
    <div className="intro-area section-padding white" id="intro">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h2 className="section-title">Our Services</h2>
            <div className="sub-heading">
              <p>Check out some of our services</p>
            </div>
          </div>
        </div>

        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-sm-6 col-md-6 col-lg-3">
              <div className="intro-block">
                <div className="intro-icon-wrapper">
                  <span className="intro-icon"><i className={service.icon}></i></span>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <p className="read-more"><a href={service.link}>Continue reading...</a></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;